// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file pull_requests/v1/available_reviewers.proto (package github.pull_requests.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Reviewer } from "./reviewer_pb";
import { file_pull_requests_v1_reviewer } from "./reviewer_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pull_requests/v1/available_reviewers.proto.
 */
export const file_pull_requests_v1_available_reviewers: GenFile = /*@__PURE__*/
  fileDesc("CipwdWxsX3JlcXVlc3RzL3YxL2F2YWlsYWJsZV9yZXZpZXdlcnMucHJvdG8SF2dpdGh1Yi5wdWxsX3JlcXVlc3RzLnYxIlwKGkF2YWlsYWJsZVJldmlld2Vyc1Jlc3BvbnNlEj4KE2F2YWlsYWJsZV9yZXZpZXdlcnMYASADKAsyIS5naXRodWIucHVsbF9yZXF1ZXN0cy52MS5SZXZpZXdlcmIGcHJvdG8z", [file_pull_requests_v1_reviewer]);

/**
 * Response payload for
 * GET /:owner/:repo/pull/:number/page_data/reviewers
 *
 * Defined by PullRequests::PageData::SharedController#reviewers. The filtered
 * set of users and teams the current viewer may request a review from (the
 * reviewer typeahead).
 *
 * @generated from message github.pull_requests.v1.AvailableReviewersResponse
 */
export type AvailableReviewersResponse = Message<"github.pull_requests.v1.AvailableReviewersResponse"> & {
  /**
   * @generated from field: repeated github.pull_requests.v1.Reviewer available_reviewers = 1;
   */
  availableReviewers: Reviewer[];
};

/**
 * Describes the message github.pull_requests.v1.AvailableReviewersResponse.
 * Use `create(AvailableReviewersResponseSchema)` to create a new message.
 */
export const AvailableReviewersResponseSchema: GenMessage<AvailableReviewersResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_available_reviewers, 0);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(AvailableReviewersResponseSchema, "0e0070e29c27")
